import { Outlet } from "@remix-run/react";

export const loader = () => null;

const Auth = () => <Outlet />;

export default Auth;
